import React from "react"
import clsx from "clsx"
import types from "prop-types"
import SvgSpriteIcon from "shared/SvgSpriteIcon"
import { useTabNavigationWithKeyboard } from "hooks"

const isActive = (index, activeIndex) => (index === activeIndex)

const HiddenSideTabs = ({
  className = "",
  tabs,
  initialActiveIndex = 0,
  SideTabContents,
  sideTabContentClassName = "side-tabs-container",
}) => {
  const {
    activeIndex, tabRef, changeActiveTab, handleKeyDown,
  } = useTabNavigationWithKeyboard(tabs, initialActiveIndex)

  return (
    <div className={clsx(className, "flex")}>
      <ol
        className="mr-8"
        role="menu"
        aria-orientation="vertical"
        aria-label="side tabs"
      >
        {
          tabs.map(({ iconName, title }, index) => {
            const isActiveTab = index === activeIndex
            return (
              <li
                key={title}
                className={clsx(
                  !isActive(index, activeIndex) && "text-dark",
                  isActive(index, activeIndex) && "font-semibold",
                  "text-right cursor-pointer text-lg mt-8 whitespace-nowrap",
                )}
                role="presentation"
              >
                {
                  (iconName) && (
                    <SvgSpriteIcon iconName={iconName} className="mr-2" />
                  )
                }
                <button
                  className={clsx(isActiveTab && "active")}
                  aria-label={title}
                  onClick={(e) => changeActiveTab(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  tabIndex={isActiveTab ? 0 : -1}
                  role="menuitem"
                  ref={(el) => {
                    tabRef.current[index] = el
                  }}
                >
                  {title}
                </button>
              </li>
            )
          })
        }
      </ol>

      <div className={sideTabContentClassName}>
        <SideTabContents tabs={tabs} activeIndex={activeIndex} />
      </div>
    </div>
  )
}

HiddenSideTabs.propTypes = {
  className: types.string,
  tabs: types.arrayOf(types.object).isRequired,
  initialActiveIndex: types.number,
  sideTabContentClassName: types.string,
  SideTabContents: types.func.isRequired,
}

export default HiddenSideTabs
